import BarnSheetsFarms from './BarnSheetsFarms';

export default BarnSheetsFarms;
